import { getAssetUrl } from '@/utils/common';

export const lines = [
  {
    id: '1',
    image: getAssetUrl('images/bg'),
    addr: '凤凰山',
    time: '熙宁五年\n(1072)',
    theme: '《江城子》',
    poem: '凤凰山下雨初晴，水风清，晚霞明。\n千朵芙蓉，开过尚盈盈。\n何处飞来双白鹭，如有意，慕娉婷。\n忽闻江上弄哀筝，苦含情，遣谁听。\n烟敛云收，依约是湘灵。\n欲待曲终寻问取，人不见，数峰青。'
  },
  {
    id: '2',
    image: getAssetUrl('images/bg'),
    addr: '下天竺',
    time: '熙宁五年\n(1072)',
    theme: '《雨中邀李范庵过天竺寺作》',
    poem: '凤凰山下雨初晴，水风清，晚霞明。\n千朵芙蓉，开过尚盈盈。\n何处飞来双白鹭，如有意，慕娉婷。\n忽闻江上弄哀筝，苦含情，遣谁听。\n烟敛云收，依约是湘灵。\n欲待曲终寻问取，人不见，数峰青。'
  },
  {
    id: '3',
    image: getAssetUrl('images/bg'),
    addr: '西湖石屋洞',
    time: '熙宁五年\n(1072)',
    theme: '《雨中邀李范庵过天竺寺作》',
    poem: '凤凰山下雨初晴，水风清，晚霞明。\n千朵芙蓉，开过尚盈盈。\n何处飞来双白鹭，如有意，慕娉婷。\n忽闻江上弄哀筝，苦含情，遣谁听。\n烟敛云收，依约是湘灵。\n欲待曲终寻问取，人不见，数峰青。'
  },
  {
    id: '4',
    image: getAssetUrl('images/bg'),
    addr: '飞来峰',
    time: '熙宁五年\n(1072)',
    theme: '《雨中邀李范庵过天竺寺作》',
    poem: '凤凰山下雨初晴，水风清，晚霞明。\n千朵芙蓉，开过尚盈盈。\n何处飞来双白鹭，如有意，慕娉婷。\n忽闻江上弄哀筝，苦含情，遣谁听。\n烟敛云收，依约是湘灵。\n欲待曲终寻问取，人不见，数峰青。'
  },
  {
    id: '5',
    image: getAssetUrl('images/bg'),
    addr: '飞来峰',
    time: '熙宁五年\n(1072)',
    theme: '《雨中邀李范庵过天竺寺作》',
    poem: '凤凰山下雨初晴，水风清，晚霞明。\n千朵芙蓉，开过尚盈盈。\n何处飞来双白鹭，如有意，慕娉婷。\n忽闻江上弄哀筝，苦含情，遣谁听。\n烟敛云收，依约是湘灵。\n欲待曲终寻问取，人不见，数峰青。'
  },
  {
    id: '6',
    image: getAssetUrl('images/bg'),
    addr: '飞来峰',
    time: '熙宁五年\n(1072)',
    theme: '《雨中邀李范庵过天竺寺作》',
    poem: '凤凰山下雨初晴，水风清，晚霞明。\n千朵芙蓉，开过尚盈盈。\n何处飞来双白鹭，如有意，慕娉婷。\n忽闻江上弄哀筝，苦含情，遣谁听。\n烟敛云收，依约是湘灵。\n欲待曲终寻问取，人不见，数峰青。'
  },
  {
    id: '7',
    image: getAssetUrl('images/bg'),
    addr: '飞来峰',
    time: '熙宁五年\n(1072)',
    theme: '《雨中邀李范庵过天竺寺作》',
    poem: '凤凰山下雨初晴，水风清，晚霞明。\n千朵芙蓉，开过尚盈盈。\n何处飞来双白鹭，如有意，慕娉婷。\n忽闻江上弄哀筝，苦含情，遣谁听。\n烟敛云收，依约是湘灵。\n欲待曲终寻问取，人不见，数峰青。'
  },
  {
    id: '8',
    image: getAssetUrl('images/bg'),
    addr: '飞来峰',
    time: '熙宁五年\n(1072)',
    theme: '《雨中邀李范庵过天竺寺作》',
    poem: '凤凰山下雨初晴，水风清，晚霞明。\n千朵芙蓉，开过尚盈盈。\n何处飞来双白鹭，如有意，慕娉婷。\n忽闻江上弄哀筝，苦含情，遣谁听。\n烟敛云收，依约是湘灵。\n欲待曲终寻问取，人不见，数峰青。'
  },
];

export const characterImgs = [
  {
    name: '巴金',
    width: 262,
    left: 45,
    image: getAssetUrl('images/route/characterImgs/巴金.png')
  },
  {
    name: '白居易',
    width: 262,
    left: 40,
    image: getAssetUrl('images/route/characterImgs/白居易.png')
  },
  {
    name: '范仲淹',
    width: 258,
    left: 38,
    image: getAssetUrl('images/route/characterImgs/范仲淹.png')
  },
  {
    name: '冯雪峰',
    width: 262,
    left: 34,
    image: getAssetUrl('images/route/characterImgs/冯雪峰.png')
  },
  {
    name: '陆游',
    width: 248,
    left: 38,
    image: getAssetUrl('images/route/characterImgs/陆游.png')
  },
  {
    name: '马一浮',
    width: 188,
    left: 75,
    image: getAssetUrl('images/route/characterImgs/马一浮.png')
  },
  {
    name: '钱镠',
    width: 278,
    left: 32,
    image: getAssetUrl('images/route/characterImgs/钱镠.png')
  },
  {
    name: '苏轼',
    width: 372,
    left: -14,
    image: getAssetUrl('images/route/characterImgs/苏轼.png')
  },
  {
    name: '王旭烽',
    width: 128,
    left: 128,
    image: getAssetUrl('images/route/characterImgs/王旭烽.png')
  },
  {
    name: '李叔同',
    width: 405,
    left: -36,
    image: getAssetUrl('images/route/characterImgs/李叔同.png')
  },
  {
    name: '于谦',
    width: 246,
    left: 32,
    image: getAssetUrl('images/route/characterImgs/于谦.png')
  },
  {
    name: '郁达夫',
    width: 188,
    left: 90,
    image: getAssetUrl('images/route/characterImgs/郁达夫.png')
  },
  {
    name: '岳飞',
    width: 262,
    left: 40,
    image: getAssetUrl('images/route/characterImgs/岳飞.png')
  },
  {
    name: '张岱',
    width: 278,
    left: 27,
    image: getAssetUrl('images/route/characterImgs/张岱.png')
  },
  {
    name: '鲁迅',
    width: 275,
    left: 42,
    image: getAssetUrl('images/route/characterImgs/鲁迅.png')
  },
  {
    name: '林逋',
    width: 200,
    left: 68,
    image: getAssetUrl('images/route/characterImgs/林逋.png')
  },
];

export const getRandomInt = (min: number, max: number) => {
  const low = Math.ceil(min);
  const high = Math.floor(max);
  return Math.floor(Math.random() * (high - low + 1)) + low;
}

export const randomSize = [
  546, 447, 378, 500, 376, 331, 460, 366, 301, 454,
  396, 369, 526, 311, 399, 478, 363, 540, 549, 507,
  386, 556, 398, 352, 414, 422, 401, 481, 340, 343,
  545, 411, 486, 519, 309, 500, 533, 423, 404, 413,
  347, 343, 456, 319, 336, 479, 384, 550, 287, 428,
  546, 478, 510, 396, 316, 554, 331, 481, 548, 539,
  343, 529, 406, 448, 538, 389, 458, 384, 326, 270,
  263, 528, 321, 438, 495, 284, 353, 369, 481, 524,
  341, 378, 496, 456, 471, 513, 329, 297, 420, 276,
  321, 535, 346, 336, 332, 419, 291, 287, 357, 556
];
